import type { Identifiers } from '@atlaskit/feature-gate-js-client';
import { FeatureGatesInitialization } from '@atlassian/feature-gates-react';
import React, { PropsWithChildren, useMemo } from 'react';

import { featureGatesOptions } from '@townsquare/stat-sig';
import { User } from '@townsquare/user-store';
import { WorkspaceDetails } from '@townsquare/workspace-store';

import { FullScreenSpaLoader } from '../ui/FullScreenSpaLoader';

type StatSigInitProps = {
  accountId: User['accountId'];
  orgId?: string;
  cloudId?: WorkspaceDetails['cloudId'];
};

export function StatSigInit({ accountId, orgId, cloudId, children }: PropsWithChildren<StatSigInitProps>) {
  const featureGatesIdentifiers = useMemo<Identifiers>(
    () => ({
      atlassianAccountId: accountId,
      atlassianOrgId: orgId,
      // Existence of this field is not guaranteed, so we need to check it before using it
      tenantId: cloudId,
    }),
    [accountId, orgId, cloudId],
  );

  return (
    <FeatureGatesInitialization
      options={featureGatesOptions}
      identifiers={featureGatesIdentifiers}
      initializingComponent={<FullScreenSpaLoader />}
      customAttributes={{
        targetApp: 'atlas_web',
      }}
    >
      {children}
    </FeatureGatesInitialization>
  );
}
